export default __webpack_public_path__ + "static/media/clock.6c33a176.png";